import ColorSchemeSwitch from './ColorSchemeSwitch';

export default function Settings() {
  return (
    <div className="settings">
      <ColorSchemeSwitch />
    </div>
  );
}
